<template>
  <div class="App"></div>
</template>

<script>
import gmapsInit from "../utils/gmaps";

export default {
  name: "Gmaps",
  //props:['address'],
  data: () => ({
    google:undefined,
    geocoder: undefined,
    map: undefined
    //address = 'Manaus'
  }),
  mounted() {
    if (!this.address) this.address = "Manaus Brazil";
    this.initConfig();
  },
  methods: {
    clear () {
      if(this.map){
        this.initConfig();
      }
    },
    async initConfig() {
      try {
        this.google = await gmapsInit();
        this.geocoder = new this.google.maps.Geocoder();
        let latlng = new this.google.maps.LatLng(-3.1190275, -60.0217314);
        let mapOptions = {
          zoom: 12,
          center: latlng,
          mapTypeId: this.google.maps.MapTypeId.ROADMAP
        };
        this.map = new this.google.maps.Map(this.$el, mapOptions);
        /* let latlng = new google.maps.LatLng(-3.1190275, -60.02173140000002)
        let mapOptions = {
          zoom: 8,
          center: latlng,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        }
        this.map = new google.maps.Map(document.getElementById('map_canvas'), mapOptions) */
        //this.positionAddress('Manaus')
      } catch (error) {
        console.error(error);
      }
    },
    positionAddress(address) {
      //console.log('GMaps',address)
      let addressValidate = address ? address : ''
      this.geocoder.geocode(
        { address: addressValidate + " Manaus Amazonas" },
        (results, status) => {
          if (status !== "OK" || !results[0]) {
            throw new Error(status);
          }
          this.$emit("locationFound", {
            address: results[0].formatted_address,
            latitude: results[0].geometry.location.lat(),
            longitude: results[0].geometry.location.lng()
          });
          this.map.setCenter(results[0].geometry.location);
          this.map.fitBounds(results[0].geometry.viewport);
          if(address)
            this.markMap({lat:results[0].geometry.location.lat(),lng:results[0].geometry.location.lng()})
        }
      );

      return this.address;
    },
    markMap(latLng){

      var marker = new this.google.maps.Marker({
        position: new this.google.maps.LatLng(latLng.lat, latLng.lng),
        map: this.map,
      });
    },
  },
  computed: {
    teste() {
      return this.address;
    },
    search() {
      let value = this.$store.getters.searchAddress;
      if (!value) value = "Manaus amazonas";
      return value;
    }
  }
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
}

.App {
  width: 100%;
  height: 38vh;
}
</style>
